import React from 'react';
import { Space, Typography } from 'antd';
import { F } from '@/utils/intl';
import styles from './AppointmentFooterMeta.less';

const { Text } = Typography;

type Creator = { firstname?: string | null; lastname?: string | null; fullname?: string | null; email?: string | null };

const getCreatorName = (creator?: Creator | null) =>
  creator
    ? [creator.firstname, creator.lastname].filter(Boolean).join(' ') || creator.fullname || creator.email || ''
    : '';

/**
 * Who created the appointment and its id, kept small at the right of the
 * drawer footer. Only some responses carry `creator`; the id is always shown.
 */
const AppointmentFooterMeta: React.FC<{ appointment?: { id?: string; creator?: Creator | null } | null }> = ({
  appointment,
}) => {
  if (!appointment?.id) return null;
  const creatorName = getCreatorName(appointment.creator);

  return (
    <Space size={16} className={styles.meta}>
      {creatorName && (
        <Text type="secondary">
          <F id="common.attribute.created_by" defaultMessage="Created by" />: {creatorName}
        </Text>
      )}
      <Text type="secondary">
        ID{' '}
        <Text code copyable className={styles.id}>
          {appointment.id}
        </Text>
      </Text>
    </Space>
  );
};

export default React.memo(AppointmentFooterMeta);
